import type {
	IVehicleTuningShopItem,
	IVehicleTuningShopItemVariant,
} from '~/rage/services/VehicleTuningShopService';

export function getActiveVariant(
	item: IVehicleTuningShopItem | undefined,
	activeVariants: Record<string, number>,
): IVehicleTuningShopItemVariant | null {
	if (!item?.variants?.length) {
		return null;
	}
	const raw = activeVariants[item.id] ?? 0;
	const idx = Math.min(Math.max(0, raw), item.variants.length - 1);
	return item.variants[idx] ?? null;
}

function extractBaseName(name: string): string {
	return name.replace(/\s*\([^)]*\)\s*$/, '').trim();
}

function extractLabel(name: string): string {
	const match = name.match(/\(([^)]*)\)\s*$/);
	return match ? match[1].trim() : name.trim();
}

/** Id, price и подпись для превью / покупки / владения */
export function getEffectiveTuningSelection(
	item: IVehicleTuningShopItem | undefined,
	activeVariants: Record<string, number>,
): { id: string; price: number; installLabel: string; parentName: string } {
	if (!item) {
		return { id: '', price: 0, installLabel: '', parentName: '' };
	}
	const v = getActiveVariant(item, activeVariants);
	const id = v?.id ?? item.id;
	const price = v?.price ?? item.price;
	const parentName = extractBaseName(item.name);
	const variantLabel = v?.name ? extractLabel(v.name) : null;
	const installLabel = variantLabel
		? `${parentName} (${variantLabel})`
		: parentName;
	return { id, price, installLabel, parentName };
}
